var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "border-box",
        staticStyle: {
          "min-width": "400px",
          width: "40vw",
          margin: "auto",
          "margin-top": "100px",
        },
      },
      [
        !_vm.isStatusRequested
          ? _c("div", [
              _c("div", [
                _c("h3", { staticClass: "fg-color-blue" }, [
                  _vm._v("Reset password request"),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "Email" } }, [
                      _vm._v("Email:"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "email" },
                      domProps: { value: _vm.email },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.email = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("ValidationError", {
                      attrs: { context: "Email", errors: _vm.validationErrors },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isStatusNotRequested,
                        expression: "isStatusNotRequested",
                      },
                    ],
                    staticClass: "btn btn-primary btn-lg btn-block",
                    attrs: { type: "button" },
                    on: { click: _vm.handleRequestResetPasswordCommandV1 },
                  },
                  [_vm._v("Request")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isStatusRequesting,
                        expression: "isStatusRequesting",
                      },
                    ],
                    staticClass: "btn btn-primary btn-lg btn-block",
                    attrs: { type: "button", disabled: "" },
                  },
                  [_vm._v("Requesting...")]
                ),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _c("div", [
              _c("h1", [_vm._v("Your request was sent")]),
              _vm._v(" "),
              _c("h4", [
                _vm._v(
                  "\n                If you have an active account in TransparentChoice then you will get an email with reset password link valid 24h.\n                Please use this link to set a new password.\n            "
                ),
              ]),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", [
      _c("span", [_vm._v("Already have an account?")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "/#/signin" } }, [_vm._v("Sign-in")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }